import { IShow, TaskTimeLineType } from "@evennt-tech/api-v2-core";
import { useQuery } from "@tanstack/react-query";
import { RequestKey } from "api/request-key";
import { apiV2 } from "api/firebase";
import useMapTimeline from "hooks/show/stand/task/historyTimeline/useMapTimeline";
import { ReactNode } from "react";

type UseTaskTimelineArgs = {
  show: IShow;
  standId: string;
  taskId: string;
  type?: TaskTimeLineType[];
};

type UseTaskTimeline = [ReactNode[], boolean, unknown];

export default ({
  taskId,
  standId,
  type,
  show,
}: UseTaskTimelineArgs): UseTaskTimeline => {
  const mapTimeline = useMapTimeline(show, standId);
  const enabled = Boolean(show?.id && standId && taskId);

  const { data: timelines, isLoading, isFetching, error } = useQuery({
    queryKey: [
      type?.length
        ? RequestKey.GetTaskTimelineByType
        : RequestKey.GetTaskTimeline,
      show?.id,
      standId,
      taskId,
      ...(type?.length ? [type] : []),
    ],
    queryFn: async (): Promise<ReactNode[]> => {
      try {
        const actions = await apiV2.taskTimeline.getMany({
          showId: show.id,
          taskId,
          standId,
          ...(type?.length && {
            type,
          }),
        });

        return await Promise.all(actions.map(mapTimeline));
      } catch (e) {
        console.error(e);
        return [];
      }
    },
    enabled,
    // Always-fresh: the timeline modal refetches on every open, no cache.
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: "always",
    refetchOnWindowFocus: false,
  });
  return [timelines ?? [], isLoading || isFetching, error];
};
